import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PremiumPayContainerComponent } from './premium-pay-container/premium-pay-container.component';
import { PremiumPayComponent } from './premium-pay/premium-pay.component';
import { UIRouterModule } from '@uirouter/angular';
import { PremiumPayRoute } from './premium-pay.route';
import { SharedModule } from '../shared/shared.module';
import { EntityDataService } from '@ngrx/data';
import * as fromDataServices from '../data-services';
@NgModule({
    declarations: [PremiumPayContainerComponent, PremiumPayComponent],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [PremiumPayRoute]
        })
    ]
})
export class PremiumPayModule {
    constructor() {}
}
